export default __webpack_public_path__ + "static/media/credit_border.1eaf64d1.svg";